import Vue from 'vue';
import {AUSPRAEGUNGSTATUS, OVERALLSTATUS} from "models/enums";
import {doPost, doPut} from "../classes/api";

export class ConfiguratorService {

    constructor() {
        this.numAuflagen = 0;
        this.sortenFiles = [];
        this.observableData = Vue.observable({ data: {} });
        this.basketUrl =  window.webroot + window.languagepath + '/shop-basket.html'
        this.itemUrl = `${window.webroot}myinterfaces/${window.languagepath}/shop/session/basket/items/`
        this.basketOperationInProgress = false;
        this.validationAbortController = new AbortController();
    }

    // why setters? language should be known upon creation of the service and won't change
    setLanguage( language )
    {
        this.language = language;
    }

    setProductId( productId )
    {
        this.productId = productId;

    }

    async getConfigurator(configId = null, itemId = null) {
        let urlParams = "";

        if (itemId != null) {
            urlParams = "itemId=" + itemId;
        } else if (configId != null) {
            urlParams = "configId=" + configId;
        }
        await fetch(`/api/prj/products/${this.productId}.${this.language}.json?${urlParams}`, {
            method: 'GET'
        }).then((response) => {
            return response.json()
        }).then((data) => {
            this.observableData.data = data.data;
            if( data.herstellkosten ) {
                this.observableData.herstellkosten = data.herstellkosten;
            }
            return this.observableData;
        })
    }

    async validate() {
        // abort prev request and create new controller
        this.validationAbortController.abort("Aborting validation: data changed");
        this.validationAbortController = new AbortController();

        let payload = this.lightweightConf();
        await fetch(`/api/prj/products/${this.productId}.${this.language}.json`, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal: this.validationAbortController.signal
        }).then((response) => {
            return response.json()
        }).then(( data ) => {
            this.observableData.data = data.data;

            if( data.herstellkosten ) {
                this.observableData.herstellkosten = data.herstellkosten;
            }
            return this.observableData;
        }).catch((e)=>{console.log(e)})
    }

    lightweightConf()
    {
        const selectedAuspraegungen = (this.observableData.data.configgroups).flatMap(
            group => group.konfigurationsmoeglichkeiten
                .filter( km => km.auspraegungen.find( a => a.status === AUSPRAEGUNGSTATUS.SELECTED ) )
                .map( km => km.auspraegungen.find( a => a.status === AUSPRAEGUNGSTATUS.SELECTED ).id ) );

        const dynamicValues = this.observableData.data.configgroups
            .flatMap(x => x.konfigurationsmoeglichkeiten)
            .filter(x => x.dynamicValues && Object.keys(x.dynamicValues).length !== 0 )
            .reduce( (collector,{id, dynamicValues}) => {
                return {
                    ...collector,
                    [id]:dynamicValues}
            }, {})

        return {
            selectedAuspraegungen: selectedAuspraegungen,
            dynamicValues: dynamicValues,
            newest: this.newest,
            affectedConfigOption: this.newest_configoption
        }
    }

    // helper methods for configoptions:
    getSelectedAuspraegung( option )
    {
        return option.auspraegungen.find(x => x.status === AUSPRAEGUNGSTATUS.SELECTED)
    }

    async setSelectedAuspraegung(option, auspraegungid, validate = true )
    {
        let previouslySelected = this.getSelectedAuspraegung(option);
        if (previouslySelected)
        {
            previouslySelected.status = AUSPRAEGUNGSTATUS.NORMAL;
        }
        this.newest = auspraegungid
        this.newest_configoption = option.id

        let newSelected = option.auspraegungen.find(a => a.id == auspraegungid);
        if (newSelected) {
            newSelected.status = AUSPRAEGUNGSTATUS.SELECTED;
        }

        if (validate) {
            await this.validate();
        }
        return Promise.resolve();
    }

    isAuspraegungExcluded(option, auspraegungid) {
        return option.auspraegungen.find(x => x.id == auspraegungid)?.status === AUSPRAEGUNGSTATUS.EXCLUDED
    }

    isConfigurationComplete() {
        return this.observableData.data.overallStatus.status === OVERALLSTATUS.COMPLETE;
    }

    getOverallMsg() {
        return this.observableData.data.overallStatus.message;
    }

    hasConfigoptionType ( configtype ) {
        return this.observableData.data.configgroups
            .flatMap( group => group.konfigurationsmoeglichkeiten )
            .some(configoption => configoption.configtype === configtype)
    }

    byConfigoptionType(configtype) {
        return this.observableData.data.configgroups
            .flatMap(group => group.konfigurationsmoeglichkeiten)
            .find(configoption => configoption.configtype === configtype)
    }

    // TODO: Uploads?
    saveConfiguration(name, nouser = false) {
        let url = `/myinterfaces/${this.language}/prj/saveconf/${this.productId}.json?configurationName=${name}`
        if (nouser) {
            url = url + "&foruser=0"
        }

        let payload = this.lightweightConf();
        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        }).then((response) => {
            console.log(response)
            return response.json()
        })
    }
    addOrUpdateToBasket(shopItemId)
    {
        if( this.basketOperationInProgress )
        {
            return Promise.reject("basket operation already in progress");
        }

        this.basketOperationInProgress = true;
        if(shopItemId)
        {
            return this.updateItem(shopItemId)
        }
        else
        {
            return this.addToBasket()
        }
    }
    
    addToBasket() {
        let data = JSON.stringify( this.lightweightConf() );

        const url = this.itemUrl + `${window.FlyerlineConfig.product_key}/1`

        return doPut(url, data).then(response => {

            const searchParams = new URLSearchParams({})
            $('body').trigger('basketChanged', response);

            searchParams.append("productKey", window.FlyerlineConfig.product_key)
            Prj.TrackingEvent.addToCart(searchParams.toString(), data );

            this.basketOperationInProgress = false;
        }).catch(xhr => {
            this.basketOperationInProgress = false;
            console.log(xhr)
        })
    }
    
    navigateToBasket()
    {
        location.href = this.basketUrl
    }
    
    getPdfUrl()
    {
        var data = {
            jsonConf: JSON.stringify( this.lightweightConf() )
        }
        const searchParams = new URLSearchParams( data )
        const url = '/stream/' + window.languagepath + '/product-information.pdf'+'?'+searchParams.toString()+'&productId=' + this.productId;
        
        return url;
    }

    setSample(config) {
        for( const selectedAuspraegung of config.selectedAuspraegungen ) {
           console.log( selectedAuspraegung ) 
        }
            
    }
    updateItem(shopItemId) {
        var data = {
            config: JSON.stringify( this.lightweightConf() )
        }
        const searchParams = new URLSearchParams( data )

        const url = this.itemUrl + `${shopItemId}/1`;

        return doPost(url, searchParams, "application/x-www-form-urlencoded")
            .then(response => {
                this.basketOperationInProgress = false;
                $('body').trigger('basketChanged', response);
            })
            .catch(xhr => {
                console.log('The request failed!', xhr)
                this.basketOperationInProgress = false;
            })
        // redirecting would probably be good to be done outside the api
    }

    getPrintRunOrQuantity(){
        if ( this.isConfigTypePresent('Auflage') ){
            return this.numAuflagen;
        }
        return this.byConfigoptionType('Quantity').dynamicValues.anzahlStueck
    }



    isConfigTypePresent(type) {
        return (this.observableData.data.configgroups.map(x => x.konfigurationsmoeglichkeiten)).flat().some(k => k.configtype === type)
    }

    showGroup(group) {
        if (group.konfigurationsmoeglichkeiten.some(x => x.configtype !== 'Druckdatei Upload')) {
            return true;
        }
        return group.konfigurationsmoeglichkeiten.some(x => x.customValues['showUploadFile'])
    }


}